export var InsightSource;
(function (InsightSource) {
    InsightSource["Cases"] = "cases";
    InsightSource["Creditors"] = "creditors";
    InsightSource["Satisfactions"] = "satisfactions";
    InsightSource["CaseVouchers"] = "case-vouchers";
    InsightSource["BillingVouchers"] = "billing-vouchers";
    InsightSource["Users"] = "users";
    InsightSource["Updates"] = "updates";
    InsightSource["UpdateTypes"] = "update-types";
    InsightSource["Workflows"] = "workflows";
    InsightSource["WorkflowTasks"] = "workflow-tasks";
    InsightSource["CaseStatuses"] = "case-statuses";
    InsightSource["Interactions"] = "interactions";
    InsightSource["Documents"] = "documents";
    InsightSource["PaymentPlans"] = "payment-plans";
    InsightSource["PaymentPlanEntries"] = "payment-plan-entries";
    InsightSource["Customers"] = "customers";
    InsightSource["UsersOnCustomers"] = "users-on-customers";
    InsightSource["Properties"] = "properties";
})(InsightSource || (InsightSource = {}));
export var ColumnType;
(function (ColumnType) {
    ColumnType["Text"] = "string";
    ColumnType["Number"] = "double";
    ColumnType["Integer"] = "int64";
    ColumnType["Boolean"] = "boolean";
    ColumnType["DateTime"] = "dateTime";
    ColumnType["Json"] = "json";
})(ColumnType || (ColumnType = {}));
const columns = (type, names) => names.split(' ').map((name) => ({ name, type }));
// Column names match the public insights feeds, including their legacy identifiers.
export const dataSources = [
    {
        id: InsightSource.Cases,
        columns: [
            ...columns(ColumnType.Text, 'caseId customerId referenceId status endReasonId exitReason creditorId caseGroupId caseGroupLabel associationId workflowId workflowCurrentTaskId workflowNextTaskId workflowNextTaskType'),
            ...columns(ColumnType.Integer, 'id'),
            ...columns(ColumnType.DateTime, 'createdAt statusTime workflowCurrentTaskDate workflowNextTaskDate'),
            ...columns(ColumnType.Boolean, 'isCompany'),
            ...columns(ColumnType.Json, 'tags'),
        ],
    },
    {
        id: InsightSource.Creditors,
        columns: [
            ...columns(ColumnType.Text, 'creditorId referenceId name state centralRegisterId acquisitionResponsibleUserId creditorContactUserId tenantContactUserId'),
            ...columns(ColumnType.DateTime, 'createdAt'),
            ...columns(ColumnType.Boolean, 'isCompany'),
            ...columns(ColumnType.Json, 'address'),
        ],
    },
    {
        id: InsightSource.Satisfactions,
        columns: [
            ...columns(ColumnType.Text, 'satisfactionId caseId comment'),
            ...columns(ColumnType.Number, 'satisfaction'),
        ],
    },
    {
        id: InsightSource.CaseVouchers,
        columns: [
            ...columns(ColumnType.Text, 'caseId caseVoucherId voucherTypeId referenceCaseVoucherId category referenceId currency label createdById createdByType source state'),
            ...columns(ColumnType.Number, 'amount originalAmount expiredAmount irrecoverableAmount interest'),
            ...columns(ColumnType.DateTime, 'createdAt date dueDate expirationDate deletedAt'),
            ...columns(ColumnType.Boolean, 'expired'),
        ],
    },
    {
        id: InsightSource.BillingVouchers,
        columns: [
            ...columns(ColumnType.Text, 'billingVoucherId creditorId caseId billingId voucherTypeId type currency label pdfFileUrl depositCaseVoucherId caseVoucherId vatOfBillingVoucherId ofVoucherTypeId ofVoucherTypeLabel fromVoucherTypeId fromVoucherTypeLabel vatOfVoucherTypeId vatOfVoucherTypeLabel'),
            ...columns(ColumnType.Boolean, 'isAdjustment'),
            ...columns(ColumnType.DateTime, 'billingDate date'),
            ...columns(ColumnType.Number, 'amount'),
        ],
    },
    {
        id: InsightSource.Users,
        columns: [
            ...columns(ColumnType.Text, 'userId role email firstName lastName'),
            ...columns(ColumnType.Json, 'scopes creditors'),
        ],
    },
    {
        id: InsightSource.Updates,
        columns: [
            ...columns(ColumnType.Text, 'updateId updateTypeId referenceId taskId'),
            ...columns(ColumnType.Json, 'continuedByUserId createdByUserId'),
            ...columns(ColumnType.DateTime, 'createdAt remindedAt continuedAt pausedAt'),
        ],
    },
    {
        id: InsightSource.UpdateTypes,
        columns: [
            ...columns(ColumnType.Text, 'updateTypeId label referenceType'),
            ...columns(ColumnType.Boolean, 'pausing important procedureEnabled'),
        ],
    },
    {
        id: InsightSource.Workflows,
        columns: columns(ColumnType.Text, 'id title description'),
    },
    {
        id: InsightSource.WorkflowTasks,
        columns: [
            ...columns(ColumnType.Text, 'workflowId taskId updateTypeId'),
            ...columns(ColumnType.Json, 'position'),
        ],
    },
    {
        id: InsightSource.CaseStatuses,
        columns: [
            ...columns(ColumnType.Text, 'caseId status exitReason createdByUserId'),
            ...columns(ColumnType.DateTime, 'createdAt'),
        ],
    },
    {
        id: InsightSource.Interactions,
        columns: [
            ...columns(ColumnType.Text, 'interactionId referenceId referenceType type state direction createdByUserId'),
            ...columns(ColumnType.DateTime, 'createdAt'),
        ],
    },
    {
        id: InsightSource.Documents,
        columns: [
            ...columns(ColumnType.Text, 'documentId referenceId referenceType type createdByUserId fileId contentType fileName'),
            ...columns(ColumnType.DateTime, 'date createdAt signedAt'),
            ...columns(ColumnType.Boolean, 'isFoundation'),
        ],
    },
    {
        id: InsightSource.PaymentPlans,
        columns: [
            ...columns(ColumnType.Text, 'caseId paymentPlanId status createdByUserId documentId'),
            ...columns(ColumnType.DateTime, 'createdAt'),
            ...columns(ColumnType.Boolean, 'twoHourActivationReminder oneDayActivationReminder threeDayActivationReminder'),
        ],
    },
    {
        id: InsightSource.PaymentPlanEntries,
        columns: [
            ...columns(ColumnType.Text, 'paymentPlanId paymentPlanEntryId status'),
            ...columns(ColumnType.DateTime, 'reminder date deadline cancel'),
            ...columns(ColumnType.Number, 'amount'),
        ],
    },
    {
        id: InsightSource.Customers,
        columns: [
            ...columns(ColumnType.Text, 'customerId createdByUserId creditorId referenceId'),
            ...columns(ColumnType.DateTime, 'createdAt'),
            ...columns(ColumnType.Boolean, 'isCompany'),
        ],
    },
    {
        id: InsightSource.UsersOnCustomers,
        columns: [
            ...columns(ColumnType.Text, 'customerId createdByUserId id lang relation'),
            ...columns(ColumnType.DateTime, 'createdAt'),
            ...columns(ColumnType.Json, 'contact details'),
        ],
    },
    {
        id: InsightSource.Properties,
        columns: [
            ...columns(ColumnType.Text, 'propertyId ref refId type handle label description scope scopeId'),
            ...columns(ColumnType.Json, 'scopes data'),
        ],
    },
];
// One parent per table avoids ambiguous filter paths. Polymorphic references are documented separately.
export const relationships = [
    {
        fromTable: InsightSource.Customers,
        fromColumn: 'creditorId',
        toTable: InsightSource.Creditors,
        toColumn: 'creditorId',
    },
    {
        fromTable: InsightSource.Cases,
        fromColumn: 'customerId',
        toTable: InsightSource.Customers,
        toColumn: 'customerId',
    },
    {
        fromTable: InsightSource.Satisfactions,
        fromColumn: 'caseId',
        toTable: InsightSource.Cases,
        toColumn: 'caseId',
    },
    {
        fromTable: InsightSource.CaseVouchers,
        fromColumn: 'caseId',
        toTable: InsightSource.Cases,
        toColumn: 'caseId',
    },
    {
        fromTable: InsightSource.BillingVouchers,
        fromColumn: 'caseId',
        toTable: InsightSource.Cases,
        toColumn: 'caseId',
    },
    {
        fromTable: InsightSource.CaseStatuses,
        fromColumn: 'caseId',
        toTable: InsightSource.Cases,
        toColumn: 'caseId',
    },
    {
        fromTable: InsightSource.PaymentPlans,
        fromColumn: 'caseId',
        toTable: InsightSource.Cases,
        toColumn: 'caseId',
    },
    {
        fromTable: InsightSource.PaymentPlanEntries,
        fromColumn: 'paymentPlanId',
        toTable: InsightSource.PaymentPlans,
        toColumn: 'paymentPlanId',
    },
    {
        fromTable: InsightSource.UsersOnCustomers,
        fromColumn: 'customerId',
        toTable: InsightSource.Customers,
        toColumn: 'customerId',
    },
    {
        fromTable: InsightSource.Updates,
        fromColumn: 'updateTypeId',
        toTable: InsightSource.UpdateTypes,
        toColumn: 'updateTypeId',
    },
    {
        fromTable: InsightSource.WorkflowTasks,
        fromColumn: 'workflowId',
        toTable: InsightSource.Workflows,
        toColumn: 'id',
    },
];
export const insightScope = (source) => `read:insights.${source}`;
//# sourceMappingURL=data-sources.js.map